import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ToastTypes } from "../../../contexts/toastr.context";
import { useAppService } from "../../../hooks/use-app-service";
import useLang from "../../../hooks/use-lang.hook";
import { createPostDetailPageRouteFromSlug } from "../../../_pages/post-detail.page";
import { CommunityService, PostService, UserService } from "../../../_service";
import {
  highlightPost,
  unHighlightPost,
} from "../../../_store/highlighted-posts.store";
import {
  addSectionPinnedPost,
  removeSectionPinnedPosts,
} from "../../../_store/sections.store";
import { ActionModal } from "../../action-modal.component";
import BlockModal from "../../block-modal";
import IconButton from "../../icon-button.component";
import IconMenu2, { ActionType } from "../../icon-menu-2.component";
import ReportModal from "../../report-modal.component";
import UpdatePost from "../edit";
import PostLiveStatus from "./post-live-status.component";
import { MovePostModal } from "../../move-post-modal.component";

function PostMenuActionsComponent({
  community,
  post,
  updatePost,
  deletePost,
  user,
  group,
  setEmbedModalVisible,
  setIsProcessing,
  addToast,
  // state
  highlightedPostIds,
  // dispatch
  highlightPost,
  unHighlightPost,
  addSectionPinnedPost,
  removeSectionPinnedPosts,
}) {
  // const [dropDownVisible, setDropDownVisible] = useState(false);
  const [isBeingEdit, setIsBeingEdit] = useState(false);
  const [movePostModal, setMovePostModal ] = useState(false);

  const { analyticsService } = useAppService();

  // Display model to copy post url if value is set to `true`
  // const [isCopyUrlModalVisible, setCopyUrlModalVisible] = useState(false);

  const isSharedPost = post.sharedId != undefined && post.sharedId != null;
  const { id, isBookmarkedByMe, isPinned } = isSharedPost ? post.shared : post;
  const [deleteModal, setDeleteModal] = useState(false);

  const [members, setMembers] = useState([]);

  const [activeBlockUser, setActiveBlockUser] = useState(false);
  const [isActionLoading, setActionIsLoading] = useState(false);

  const postDescription = isSharedPost
    ? post.shared.description
    : post.description;

  const isHighlighted = highlightedPostIds?.includes(post.id);

  const lang = useLang();

  // passing handlers to block modal
  const [active, setActive] = useState(false);
  const [displayClosePrompt, setDisplayClosePrompt] = useState(false);
  const [isReportModalVisible, setReportModalVisible] = useState(false);
  const [isReportingPostNotUser, setIsReportingPostNotUser] = useState(false);

  const showBlockModal = () => {
    // set block modal visible
    setActive(true);
  };

  useEffect(() => {
    if (user?.id && community?.id) {
      CommunityService.getCommunitySubscribersPaginated(
        user,
        community.id,
        10,
        1,
      )
        .then(({ users, total }) => {
          setMembers(users);
        })
        .catch((error) => {
          console.error({ error });
        });
    }
  }, [community?.id]);

  const removeSubscriber = (subscriber) => {
    const newMembers = [...members];
    const memberIndex = newMembers.findIndex((m) => m.id === subscriber.id);
    newMembers.splice(memberIndex, 1);
    setMembers(newMembers);
  };

  return (
    <>
      <div className="PostMenuActions flex flex-1 place-content-end items-center text-secondary-foreground">
        {/* Display post share option only on original post */}
        {/* {user && !post.sharedId && (
          <button
            className="px-2 py-1 rounded text-xs hover:text-primary-light"
            onClick={(e) => {
              setCopyUrlModalVisible(true);
            }}>
            <I18>Share</I18>
          </button>
        )} */}
        {/* post pin */}
        {isPinned ? (
          <IconButton
            icon="img"
            img="/assets/vectors/pin-light-icon.svg"
            small
            className="h-8 w-8 bg-primary"
            onClick={(e) => {
              // check if admin or moderator
              if (group && ["admin", "moderator"].includes(group.myRole)) {
                // unpin the post
                setIsProcessing(true);
                PostService.unpinPost(user, id)
                  .then(({ post }) => {
                    setIsProcessing(false);
                    updatePost(post);
                    removeSectionPinnedPosts(post);
                  })
                  .catch((err) => {
                    setIsProcessing(false);
                    console.log({ err });
                  });
              }
            }}
          />
        ) : (
          <></>
        )}
        {/* live status */}
        <PostLiveStatus post={post} user={user} />
        {/* <span className="mx-2 px-2 cursor-pointer text-xs">Share</span> */}
        {/* show more options only if user logged in */}
        {user ? (
          <>
            <ReportModal
              reportType={
                isReportingPostNotUser ? "Post Report" : "User Profile Report"
              }
              contentLink={
                isReportingPostNotUser
                  ? window.location.origin +
                  createPostDetailPageRouteFromSlug(post)
                  : window.location.origin + "/user/" + post.createdBy.id
              }
              community={community}
              addToast={addToast}
              activeProps={{ isReportModalVisible, setReportModalVisible }}
              displayProps={{ displayClosePrompt, setDisplayClosePrompt }}
              content={
                isReportingPostNotUser
                  ? "post: " +
                  "title: " +
                  post.title +
                  " description: " +
                  postDescription
                  : "user-profile"
              }
            />

            {/* more options */}
            <IconMenu2
              dropdownClassName={""}
              icon="menu-dots-vertical"
              hideOnEmpty
              actions={[
                {
                  // Toggle bookmark
                  icon: "bookmark",
                  solidIcon: isBookmarkedByMe,
                  label: isBookmarkedByMe ? "Remove Bookmark" : "Bookmark",
                  onClick: () => {
                    (isBookmarkedByMe
                      ? PostService.removeBookmark(user, id)
                      : PostService.bookmarkPost(user, id)
                    )
                      .then(() => {
                        !isBookmarkedByMe &&
                          analyticsService.track("bookmark-post", {
                            postUrl:
                              window.location.origin +
                              createPostDetailPageRouteFromSlug(post),
                          });
                        // bookmark updated, update the post
                        updatePost({
                          ...post,
                          isBookmarkedByMe: !isBookmarkedByMe,
                        });
                        addToast(
                          !isBookmarkedByMe
                            ? "Bookmark added!"
                            : "Bookmark removed",
                          "",
                          !isBookmarkedByMe
                            ? ToastTypes.success
                            : ToastTypes.info
                        );
                      })
                      .catch((error) => {
                        alert(lang.trans("Failed performing action!"));
                      });
                  },
                },
                {
                  // Toggle Follow User
                  icon: user.id !== post.createdBy.id ? "user" : "",
                  label:
                    user.id !== post.createdBy.id
                      ? post.createdBy.isFollowedByMe
                        ? "Unfollow User"
                        : "Follow User"
                      : "",
                  onClick: () => {
                    (!post.createdBy.isFollowedByMe
                      ? UserService.followUser(
                        post?.createdBy?.id,
                        community?.id
                      )
                      : UserService.unfollowUser(
                        post?.createdBy?.id,
                        community?.id
                      )
                    )
                      .then(() => {
                        // follow user updated, update the post
                        updatePost({
                          ...post,
                          createdBy: {
                            ...post.createdBy,
                            isFollowedByMe: !post.createdBy.isFollowedByMe,
                          },
                        });
                        addToast(
                          !post.createdBy.isFollowedByMe
                            ? "User Followed!"
                            : "User Unfollowed!",
                          "",
                          !post.createdBy.isFollowedByMe
                            ? ToastTypes.success
                            : ToastTypes.info
                        );
                      })
                      .catch((error) => {
                        alert(lang.trans("Failed performing action!"));
                      });
                  },
                },
                {
                  // show remove pin button
                  icon: "thumbtack",
                  solidIcon: post.isPinned,
                  label:
                    group && ["admin", "moderator"].includes(group.myRole)
                      ? post.isPinned
                        ? "Remove Pin"
                        : "Pin Post"
                      : "",
                  onClick: (e) => {
                    // unpin the post
                    setIsProcessing(true);
                    (post.isPinned
                      ? PostService.unpinPost(user, post.id)
                      : PostService.pinPost(user, post.id)
                    )
                      .then(({ post }) => {
                        setIsProcessing(false);
                        if (post.isPinned) {
                          addSectionPinnedPost(post);
                        } else {
                          removeSectionPinnedPosts(post);
                        }
                        updatePost(post);
                      })
                      .catch((err) => {
                        setIsProcessing(false);
                        console.log({ err });
                      });
                  },
                },
                {
                  icon: ((group && ["admin", "moderator"].includes(group?.myRole)) || community?.myRole === "admin") ? "duplicate" : "",
                  label:
                    ((group && ["admin", "moderator"].includes(group.myRole)) || community?.myRole === "admin") ? "Duplicate Post" : "",
                  onClick: (e) => {
                    setMovePostModal(true);
                  },
                },
                {
                  // show remove highlight button
                  icon: "thumbtack",
                  solidIcon: isHighlighted,
                  label:
                    community?.myRole === "admin"
                      ? isHighlighted
                        ? "Remove from featured post"
                        : "Add to featured post"
                      : "",
                  onClick: (e) => {
                    // unpin the post
                    setIsProcessing(true);
                    if (isHighlighted) {
                      // remove highlight
                      unHighlightPost(post.id, (error) => {
                        if (!error) {
                          setIsProcessing(false);
                          addToast("Post removed from featured!");
                        }
                      });
                    } else {
                      // add highlight
                      highlightPost(post.id, (error) => {
                        if (!error) {
                          setIsProcessing(false);
                          addToast("Post set as featured!");
                        }
                      });
                    }
                    /* (false
                                          ? PostService.unpinPost(user, post.id)
                                          : highlightPost(post.id)
                                        )
                                          .then(({ post }) => {
                                            setIsProcessing(false);
                                            updatePost(post);
                                          })
                                          .catch((err) => {
                                            setIsProcessing(false);
                                            console.log({ err });
                                          }); */
                  },
                },
                {
                  // show edit button
                  icon: "edit",
                  label:
                    !isSharedPost &&
                      ((user && post.createdBy.id === user.id) || post.canEdit)
                      ? "Edit"
                      : "",
                  onClick: (e) => {
                    setIsBeingEdit(true);
                  },
                },
                {
                  // show embed button
                  icon: "globe",
                  label: !isSharedPost ? "Embed Post" : "",
                  onClick: () => {
                    setEmbedModalVisible(true);
                  },
                },
                {
                  // report post
                  icon: "flag",
                  label: !(post.createdBy.id === user.id) ? "Report Post" : "",
                  onClick: () => {
                    setIsReportingPostNotUser(true);
                    setReportModalVisible(true);
                  },
                },
                {
                  // report user
                  icon: "flag",
                  label: !(post.createdBy.id === user.id) ? "Report User" : "",
                  onClick: () => {
                    setIsReportingPostNotUser(false);
                    setReportModalVisible(true);
                  },
                },
                {
                  // show delete button
                  icon: "trash",
                  label: !isSharedPost && post.canDelete ? "Delete" : "",
                  actionType: ActionType.alert,
                  onClick: () => {
                    setDeleteModal(true);
                  },
                },
                {
                  icon: "ban",
                  label: user.id !== post.createdBy.id ? "Block" : "",
                  onClick: () => {
                    showBlockModal();
                  },
                  actionType: "alert",
                },
                {
                  icon: "user-remove",
                  label: ((user.id !== post.createdBy.id) && (user?.myRole === "admin" || group?.myRole === "admin" || group?.myRole === "moderator")) ? "Block User" : "",
                  onClick: () => {
                    setActiveBlockUser(true);
                  },
                  actionType: "alert",
                },
              ]}></IconMenu2>
          </>
        ) : (
          <></>
        )}
        <BlockModal
          community={community}
          addToast={addToast}
          activeProps={{ active, setActive }}
          displayProps={{ displayClosePrompt, setDisplayClosePrompt }}
          createdById={post.createdBy.id}
          blockCallback={() => {
            // removeSectionPinnedPosts(post);
            // deletePost(post, false);
          }}
        />
        <ActionModal
          active={deleteModal}
          header="Delete Post"
          title="Are you sure you want to delete the post?"
          setActive={setDeleteModal}
          onSubmit={() => {
            setIsProcessing(true);
            PostService.deletePost(user, post.id)
              .then((response) => {
                // update post
                setIsProcessing(false);
                deletePost(response.post);
                analyticsService.track("delete-post", {
                  groupName: post?.group.name,
                  sectionName: post?.tab.name,
                  postUrl:
                    window.location.origin +
                    createPostDetailPageRouteFromSlug(post),
                });
              })
              .catch((err) => {
                setIsProcessing(false);
              });
          }}
        />
        <ActionModal
          active={activeBlockUser}
          setActive={setActiveBlockUser}
          header="Block user from community"
          title={`Are you sure you want to block ${post?.createdBy?.name} ?`}
          isLoading={isActionLoading}
          onSubmit={(e) => {
            setActionIsLoading(true);
            CommunityService.blockUser(community.id, post?.createdBy.id, group?.id)
              .then((res) => {
                removeSubscriber(post?.createdBy);
                addToast(
                  `${post?.createdBy.name} is blocked successfully`,
                  "",
                  ToastTypes.success
                );
                setActiveBlockUser(false);
              })
              .catch((err) => {
                // addToast(err.message, '', ToastTypes.danger);
                console.log("some error occurred", { err });
                addToast(
                  "Error while blocking the community member",
                  "",
                  ToastTypes.error
                );
              })
              .finally(() => {
                setActionIsLoading(false);
              });
          }}
        />
      </div>
      {isBeingEdit ? (
        <UpdatePost
          postToUpdate={post}
          active={isBeingEdit}
          setActive={(val) => {
            // set is being edit to false
            setIsBeingEdit(false);
            // set dropdown visible to false
          }}
          user={user}
          updatePost={updatePost}
        />
      ) : (
        <></>
      )}
      {movePostModal ? (
        <MovePostModal
          post={post}
          active={movePostModal}
          setActive={setMovePostModal}
          onClose={() => {
            setMovePostModal(false);
          }}
        />
      ) : (
        <></>
      )}
      {/* Copy post url modal*/}
      {/* {!post.sharedId && (
        <SharePostModal
          post={post}
          heading="Share"
          text={
            window.location.origin + createPostDetailPageRouteFromSlug(post)
          }
          // text={createPostDetailPageRouteFromSlug(post)}
          active={isCopyUrlModalVisible}
          setActive={setCopyUrlModalVisible}
          onClose={() => {
            //  set is copy url modal visible to false
            setCopyUrlModalVisible(false);
          }}
        />
      )} */}
    </>
  );
}

const PostMenuActions = connect(
  (s) => ({
    community: s.community,
    highlightedPostIds: s.highlightedPosts.postIds,
  }),
  {
    highlightPost,
    unHighlightPost,
    addSectionPinnedPost,
    removeSectionPinnedPosts,
  }
)(PostMenuActionsComponent);

export default PostMenuActions;
